import React from 'react'
import AttrInput from '../../smart_bps/lib/attr_input'
import { getChoiceItems } from './fileAccessAdminShared'

const FILE_TYPES_ALL = 'all'

function fileTypesForDisplay(raw) {
  const types = Array.isArray(raw) ? raw.filter(Boolean) : []
  return types.length === 0 ? [FILE_TYPES_ALL] : types
}

function fileTypesOnChange(selected) {
  const values = Array.isArray(selected) ? selected.filter(Boolean) : []
  if (values.length === 0 || values.includes(FILE_TYPES_ALL)) {
    return []
  }
  return values.filter((t) => t !== FILE_TYPES_ALL)
}

function BoolCell({ id, checked, disabled, onChange }) {
  return (
    <div className="form-check mt-1">
      <input
        className="form-check-input"
        type="checkbox"
        id={id}
        checked={!!checked}
        disabled={disabled}
        onChange={(e) => onChange(!!e.target.checked)}
      />
      <label className="form-check-label" htmlFor={id}>
        Да
      </label>
    </div>
  )
}

export function StageAccessTable({ view, rows, cardFlow, formAccess, formErrors, readOnly }) {
  const access = formAccess?.stage_access_links_lnk
  const editable = access === 'edit' && !readOnly
  const showRolesColumn = rows.some((row) => ((row || {}).subject || 'all') === 'role')
  const stageTableMeta = view.props.attrs?.stage_access_links_lnk || {}
  const flowFileTypeItems = cardFlow && stageTableMeta.flow_file_types
    ? stageTableMeta.flow_file_types[cardFlow] || []
    : []
  const fileTypeSelectItems = [['all', 'Все'], ...flowFileTypeItems]
  const baseColCount = 8
  const colCount = baseColCount + (showRolesColumn ? 1 : 0) + (editable ? 1 : 0)
  const allStates = getChoiceItems(view.props.choices, 'FileAccessProjectState')
  const roleItems = getChoiceItems(view.props.choices, 'Role')
  const statesForFlow = cardFlow
    ? allStates.filter((item) => {
      const value = Array.isArray(item) ? item[0] : item?.value
      return String(value || '').startsWith(`${cardFlow}:`)
    })
    : []
  const subjectChoiceContext = { document_flow: cardFlow || '' }
  const tableError = formErrors?.stage_access_links_lnk

  function patchRow(idx, patch) {
    const next = rows.map((row, i) => (i === idx ? { ...(row || {}), ...patch } : row))
    view.setState((prev) => ({
      form_data: {
        ...(prev.form_data || {}),
        stage_access_links_lnk: next,
      },
    }))
  }

  function addRow() {
    view.setState((prev) => ({
      form_data: {
        ...(prev.form_data || {}),
        stage_access_links_lnk: [
          ...(Array.isArray(prev.form_data?.stage_access_links_lnk)
            ? prev.form_data.stage_access_links_lnk
            : []),
          {
            stage: '',
            subject: 'all',
            roles_lnk: [],
            file_types_lnk: [],
            can_read: true,
            can_upload: false,
            can_view: true,
            can_download: true,
            can_delete: false,
          },
        ],
      },
    }))
  }

  function removeRow(idx) {
    const next = rows.filter((_, i) => i !== idx)
    view.setState((prev) => ({
      form_data: {
        ...(prev.form_data || {}),
        stage_access_links_lnk: next,
      },
    }))
  }

  function onReadChange(idx, checked) {
    const patch = { can_read: checked }
    if (!checked) {
      patch.can_upload = false
      patch.can_view = false
      patch.can_download = false
      patch.can_delete = false
    }
    patchRow(idx, patch)
  }

  function rolesError(idx) {
    const key = `stage_access_links_lnk.${idx}.roles_lnk`
    return formErrors && formErrors[key]
  }

  return (
    <div className="mb-3">
      {editable && (
        <div className="mb-2">
          <button type="button" className="btn btn-sm btn-outline-primary" onClick={addRow}>
            + добавить правило
          </button>
        </div>
      )}
      <div className="table-responsive">
        <table className="table table-sm table-bordered align-middle mb-0">
          <thead>
            <tr>
              <th style={{ minWidth: 220 }}>Этап</th>
              <th style={{ minWidth: 160 }}>Кому</th>
              {showRolesColumn && <th style={{ minWidth: 200 }}>Роли</th>}
              <th style={{ minWidth: 220 }}>Типы файлов</th>
              <th style={{ minWidth: 90 }}>Чтение</th>
              <th style={{ minWidth: 90 }}>Загрузка</th>
              <th style={{ minWidth: 90 }}>Просмотр</th>
              <th style={{ minWidth: 110 }}>Скачивание</th>
              <th style={{ minWidth: 90 }}>Удаление</th>
              {editable && <th style={{ width: 56 }} />}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={colCount} className="text-muted">
                  Правила не добавлены
                </td>
              </tr>
            ) : (
              rows.map((row, idx) => {
                const canRead = !!(row || {}).can_read
                const subject = (row || {}).subject || 'all'
                const isRoleSubject = subject === 'role'
                const stageDisabled = !editable || !cardFlow || statesForFlow.length === 0
                const roleFieldError = rolesError(idx)
                return (
                  <tr key={`stage-access-${idx}`}>
                    <td>
                      <AttrInput
                        data_type="string"
                        choice_name="FileAccessProjectState"
                        widget="select2"
                        name={`stage_access_stage_${idx}`}
                        title=""
                        value={(row || {}).stage ?? ''}
                        access={stageDisabled ? 'read' : 'edit'}
                        {...(statesForFlow.length > 0 ? { choice_items: statesForFlow } : {})}
                        choices={view.props.choices}
                        onChange={(_, value) => patchRow(idx, { stage: value || '' })}
                      />
                    </td>
                    <td>
                      <AttrInput
                        data_type="string"
                        choice_name="FileAccessSubject"
                        widget="select2"
                        choice_context={subjectChoiceContext}
                        name={`stage_access_subject_${idx}`}
                        title=""
                        value={subject}
                        access={editable ? 'edit' : 'read'}
                        choices={view.props.choices}
                        onChange={(_, value) => {
                          const nextSubject = value || 'all'
                          patchRow(idx, {
                            subject: nextSubject,
                            roles_lnk: nextSubject === 'role' ? ((row || {}).roles_lnk || []) : [],
                          })
                        }}
                      />
                    </td>
                    {showRolesColumn && (
                      <td>
                        {isRoleSubject ? (
                          <>
                            <AttrInput
                              data_type="m2m_string"
                              choice_name="Role"
                              widget="select2"
                              name={`stage_access_roles_${idx}`}
                              title=""
                              value={(row || {}).roles_lnk || []}
                              access={editable ? 'edit' : 'read'}
                              error={roleFieldError}
                              {...(roleItems.length > 0 ? { choice_items: roleItems } : {})}
                              choices={view.props.choices}
                              onChange={(_, value) => patchRow(idx, { roles_lnk: value || [] })}
                            />
                          </>
                        ) : null}
                      </td>
                    )}
                    <td>
                      <AttrInput
                        data_type="m2m_string"
                        name={`stage_access_file_types_${idx}`}
                        title=""
                        value={fileTypesForDisplay((row || {}).file_types_lnk)}
                        access={editable && cardFlow && flowFileTypeItems.length > 0 ? 'edit' : 'read'}
                        {...(fileTypeSelectItems.length > 0 ? { choice_items: fileTypeSelectItems } : {})}
                        choices={view.props.choices}
                        widget="select2"
                        onChange={(_, value) => patchRow(idx, { file_types_lnk: fileTypesOnChange(value) })}
                      />
                      {!cardFlow && (
                        <span className="text-muted small">Выберите документооборот</span>
                      )}
                    </td>
                    <td>
                      <BoolCell
                        id={`stage_read_${idx}`}
                        checked={canRead}
                        disabled={!editable}
                        onChange={(v) => onReadChange(idx, v)}
                      />
                    </td>
                    <td>
                      <BoolCell
                        id={`stage_upload_${idx}`}
                        checked={(row || {}).can_upload}
                        disabled={!editable || !canRead}
                        onChange={(v) => patchRow(idx, { can_upload: v })}
                      />
                    </td>
                    <td>
                      <BoolCell
                        id={`stage_view_${idx}`}
                        checked={(row || {}).can_view}
                        disabled={!editable || !canRead}
                        onChange={(v) => patchRow(idx, { can_view: v })}
                      />
                    </td>
                    <td>
                      <BoolCell
                        id={`stage_download_${idx}`}
                        checked={(row || {}).can_download}
                        disabled={!editable || !canRead}
                        onChange={(v) => patchRow(idx, { can_download: v })}
                      />
                    </td>
                    <td>
                      <BoolCell
                        id={`stage_delete_${idx}`}
                        checked={(row || {}).can_delete}
                        disabled={!editable || !canRead}
                        onChange={(v) => patchRow(idx, { can_delete: v })}
                      />
                    </td>
                    {editable && (
                      <td className="text-center">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => removeRow(idx)}
                          title="Удалить строку"
                        >
                          <i className="ti ti-trash" />
                        </button>
                      </td>
                    )}
                  </tr>
                )
              })
            )}
          </tbody>
        </table>
      </div>
      {tableError && <div className="invalid-feedback d-block">{String(tableError)}</div>}
    </div>
  )
}
